import React from 'react';
import PaymentDetailsComponent from './payment-details.component';

const PaymentDetails = (props) => {
    return <PaymentDetailsComponent {...props} />;
};

export default PaymentDetails;
